import React, { useMemo, type ReactNode } from 'react';
import { useForm } from 'react-hook-form';

import FormContext from './context';
interface FormContextProviderProps {
  children: ReactNode;
}

const FormContextProvider = ({ children }: FormContextProviderProps) => {
  const {
    reset,
    register,
    setValue,
    handleSubmit,
    control,
    formState,
    trigger,
    getValues,
    unregister,
    watch,
    setError,
    clearErrors,
  } = useForm();

  const formValue = useMemo(() => ({
    formErrors: formState.errors,
    formControl: control,

    formReset: reset,
    formRegister: register,
    formSubmit: handleSubmit,
    formSetValue: setValue,
    formTrigger: trigger,
    formGetValues: getValues,
    formUnregister: unregister,
    formWatch: watch,
    formSetError: setError,
    formClearErrors: clearErrors,
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }), [formState, control, register]);

  return (
    <FormContext.Provider value={formValue}>
      {children}
    </FormContext.Provider>
  );
};
export const withFormProvider = (Component) => function sonComponent(props) {
  return (
    <FormContextProvider>
      <Component {...props} />
    </FormContextProvider>
  );
};

export default FormContextProvider;
